
import { useEffect, useRef, useState } from 'react';
import { Toolbar } from 'primereact/toolbar';
import ShareComponent from '../Share/share.component';
import { Dialog } from 'primereact/dialog';
import { convertTicks, downloadFileFromBlob, removeLocalStorageAfterChangeCard } from '../../utilities/common.utilities';
import { LoadError, SpecialZoomLevel, ViewMode, Viewer } from '@react-pdf-viewer/core';
import { Worker } from '@react-pdf-viewer/core';
import './footer.component.css'
import LoadingSpinner from '../loading-spinner/loading-spinner';
import { getPrivacyDocument } from '../../service/privacyDoc.service';
import { useLocation } from 'react-router-dom';
import { checkCardIsSelected, returnCardInfo } from '../../utilities/common.utilities';
import { getUserCards } from '../../service/card.service';
import cardModel from '../../static/card-model';
import moment from 'moment';
import {installPWA, onClickInstallButton, pwaInstalled} from "../../utilityPWA";
import PopupInstallComponent from '../PopupInstall/popupInstall.component';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useConnectivity } from '../../context/connectivityContext';
import { renderErrorViewerPdf } from '../../utilities/pdf-viewer.utilities';

type FooterCard = {
    groupCode: string;
    storeCode: string;
    selectedCard: string;
}
type FooterProps = {
  theme: "dark" | "high-contrast" | "light-blue";
};


    export default function FooterComponent( { theme }: FooterProps ) {
        const location = useLocation();

        const [showSharingComponent, setShowSharingComponent] = useState<boolean>(false);
        const [dateServiceTime, setDateServiceTime] = useState<string>('');
        const [showTermsOfUse, setShowTermsOfUse] = useState<boolean>(false);
        const { isOnline } = useConnectivity();

        const [card, setCard] = useState<FooterCard>({
            selectedCard: '',
            groupCode: '',
            storeCode: ''
        });

        const [showPopupInstall, setShowPopupInstall] = useState<boolean>(false);

        // Variabile che persiste tra i render senza causare re-render, utilizzata per sapere se è andata in
        // errore la visualizzazione del pdf
        const errorViewerFilePdf = useRef(false);

        // Aggiungo una chiave per forzare il re-render del componente Worker
        const [renderKeyWorker, setRenderKeyWorker] = useState(0); 
        const [releaseVersion, setReleaseVersion] = useState<string | null>(null);
        const toastFooter = useRef<Toast>(null);

        useEffect(() => {

            if (isOnline && errorViewerFilePdf.current) {
                errorViewerFilePdf.current = false;
                setRenderKeyWorker(prevKey => prevKey + 1); // Incrementa la chiave per forzare un re-render
            }

            // Funzione per ricevere messaggi dal Service Worker
            const handleServiceWorkerMessage = (event: MessageEvent) => {
                if (event.data && event.data.type === "RELEASE_VERSION_VALUE") {
                    setReleaseVersion(event.data.value);
                }
            };
            // Aggiunge un listener globale per i messaggi dal Service Worker
            navigator.serviceWorker.addEventListener("message", handleServiceWorkerMessage);

            // Recupera il valore di RELEASE_VERSION dal Service Worker
            if ("serviceWorker" in navigator && navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage({ type: "GET_RELEASE_VERSION" });

                // navigator.serviceWorker.addEventListener("message", (event) => {
                //     if (event.data && event.data.type === "RELEASE_VERSION_VALUE") {
                //         setReleaseVersion(event.data.value);
                //     }
                // });
            }
        
            const AllCustomerInfoServiceTime: number = parseInt(localStorage.getItem("GET_ALL_CUSTOMER_TIME") || '0');
            if(AllCustomerInfoServiceTime > 0){
                setDateServiceTime(convertTicks(AllCustomerInfoServiceTime));
            } else {
                setDateServiceTime(moment().format('DD/MM/YYYY HH:mm'));
            }
            
            if(checkCardIsSelected()){
              returnCardInfo().then(card => {
                setCard({
                    selectedCard: card.card,
                    groupCode: card.groupCode,
                    storeCode: card.storeCode
                });
              });
            
            } else {
              getUserCards().then( (cardData: cardModel) => {
                if(cardData?.cards?.length > 0){
                  const card = cardData.cards[0].cardNumber;
                  const groupCode = cardData.cards[0].groupId; // Groupid e groupcode rappresentano lo stesso dato
                  const storeCode = cardData.cards[0].mainStoreCode;

                  setCard({
                    selectedCard: card,
                    groupCode: groupCode.toString(),
                    storeCode: storeCode
                });
            
                } else { // no card linked
                
                }
                
              })
            }
        // Pulizia dell'evento quando il componente si smonta
        return () => {
            navigator.serviceWorker.removeEventListener("message", handleServiceWorkerMessage);
        };

        }, [location,isOnline])


        const downloadPdfPrivacy = () => {

            getPrivacyDocument(card.groupCode,card.storeCode,card.selectedCard).then(data_base64 => {

                if(data_base64) {

                    const myBuffer = Uint8Array.from(atob(data_base64), c => c.charCodeAt(0));
                    let file = new Blob([myBuffer], {type: 'application/pdf;charset=utf-8'});
                    
                    let now: Date = new Date();
                    let nomeFile: string = 'InformativaPrivacy_'+ now.getFullYear()+'_'+now.getMonth()+'_'+now.getDate();
                    downloadFileFromBlob(file, nomeFile)
                    
                }   
                else {
                    let message: string = 'Per scaricare il file PDF, bisogna essere connessi ad internet.';
                    toastFooter.current?.show({ severity: 'error', summary: 'Attenzione', detail: message });
                }
            });

            
        }


        const rechargeData = () => {
            if(isOnline) {
                //removeLocalStorageAfterChangeCard()
                localStorage.removeItem("services");
                localStorage.removeItem("allCustomerInfo");

                // Per la get pharmacy info rimuovo solo il timing in modo che quando viene richiamata questa funzione e
                // si perde la connessione, si può lo stesso vedere il codice a barra della card
                // localStorage.removeItem("pharmacyInfo");
                
                localStorage.removeItem("catalogs");
                localStorage.removeItem("points");
                localStorage.removeItem("rewards");
                localStorage.removeItem("getPrivacyProfile");
                localStorage.removeItem("getPrivacyInfo");

                localStorage.removeItem("GET_ALL_CUSTOMER_TIME");
                localStorage.removeItem("GET_REWARDS_TIME");
                localStorage.removeItem("GET_SERVICES_TIME");
                localStorage.removeItem("GET_CATALOG_TIME");
                localStorage.removeItem("GET_PHARMAINFO_TIME");
                localStorage.removeItem("GET_PROFILE_TIME");
                localStorage.removeItem("GET_POINTS_TIME");
                localStorage.removeItem("GET_PRIVACY_PROFILE");
                localStorage.removeItem("GET_PRIVACY_INFO");
                window.location.reload();
            }
        }
        
        return (
            <>
            
                <div className='flex overflow-hidden recharge-data-font-footer'>
                    <div className='flex-grow-1 flex align-items-center justify-content-end mr-2'>
                        <p className='' onClick={() => rechargeData()}>
                            {isOnline ? (
                            <i className='pi pi-refresh mr-1' style={{ fontSize: '1rem', cursor: 'pointer' }}></i>
                            ) : null}
                            Dati aggiornati al {dateServiceTime}
                        </p>
                    </div>
                </div>


            <div className='footer-login'>

                <Toast ref={toastFooter} position="top-center" />

                <PopupInstallComponent openManually={true} showBehaviorManually={showPopupInstall} 
                    onClosePopup={() => {
                        if(showPopupInstall) {
                            setShowPopupInstall(false)
                        }}
                    }
                />


            {/* {theme !== "light-blue" && (
                <div className='flex overflow-hidden'>
                    <div className='flex-grow-1 flex align-items-center justify-content-end mr-2'>
                    <p className='recharge-data-font-footer' onClick={() => rechargeData()}>
                        {isOnline ? (
                        <i className='pi pi-refresh mr-1' style={{ fontSize: '1rem', cursor: 'pointer' }}></i>
                        ) : null}
                        Dati aggiornati al {dateServiceTime}
                    </p>
                    </div>
                </div>
            )} */}

                    {/* <div style={{top: 'calc(30px - 1.1rem)', position: 'relative'}}> */}
                    <div className='position-footer-home'>
                        <Toolbar
                            start={
                                <div className='pl-2 text-white'>
                                    {/* <p className='font-footer'>Dati aggiornati al {dateServiceTime}</p> */}
                                    <p className='font-footer'>Fidelity Salus Service & Consulting Srl</p>
                                    <p className='font-footer'>Partita IVA IT02999210541</p>
                                    <p className='font-footer'>
                                        <span style={{cursor:'pointer'}} onClick={() => { downloadPdfPrivacy() }}>
                                            Informativa Privacy
                                        </span>
                                        <span> | </span>
                                        <span style={{cursor:'pointer'}} onClick={() => {setShowTermsOfUse(true)}}>
                                            Termini di utilizzo
                                        </span>
                                    </p>
                                    <p className='font-footer'>Non viene utilizzato alcun tipo di cookie</p>
                                    
                                    <div style={{fontSize: '9px', color: 'white', marginLeft: '3px'}}>V. {releaseVersion}</div>
                                    
                                </div>
                            }
                            end={
                                <div className='flex flex-column align-items-end'>
                                    <div className='flex flex-row'>
                                        {pwaInstalled() === false ?
                                        <div className='flex flex-column justify-content-center align-items-center mr-3' onClick={() => onClickInstallButton(setShowPopupInstall)}>
                                            <i id='installButton' className="pi pi-download" style={{  display: 'none !important', fontSize: '1.5rem', color: 'white', cursor:'pointer' }}></i>
                                            <span style={{fontSize: '8px', color: 'white', fontWeight: 'bold'}} className='pt-2'>INSTALLA</span>
                                        </div>
                                        :<></>}
                                        <div className='flex flex-column justify-content-center align-items-center pr-2' onClick={() => setShowSharingComponent(true)}>
                                            <i className="pi pi-share-alt" style={{ fontSize: '1.5rem', color: 'white', cursor:'pointer' }}></i>
                                            <span style={{fontSize: '8px', color: 'white', fontWeight: 'bold'}} className='pt-2'>CONDIVIDI</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            style={{background: 'transparent', height: '70px', border: 0}}/>
                    </div>
                    {showSharingComponent ? 
                        <Dialog header="CONDIVIDI L'APP" draggable={false} modal={true} blockScroll={true} dismissableMask={true} visible={showSharingComponent} style={{ width: '98%', maxWidth: '500px' }} onHide={() => setShowSharingComponent(false)}> {/*  width: '95vw'*/}
                            <ShareComponent></ShareComponent>
                        </Dialog>
                        : <></>
                    }

                    {
                        showTermsOfUse ?
                        <Dialog  header="Informativa privacy" modal={true} blockScroll={true} dismissableMask={true} visible={showTermsOfUse} 
                            className="panel-class-dialog-privacy" onHide={() => setShowTermsOfUse(false)} style={{ width: '95%', maxWidth: '500px' }}
                            position='bottom' draggable={false}
                            >

                            {
                                (!isOnline && errorViewerFilePdf.current)
                                ?
                                renderErrorViewerPdf()
                                :
                                <Worker 
                                key={renderKeyWorker} // Cambiando la chiave, viene forzato il re-render
                                workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                    <Viewer fileUrl="Informativa_privacy.pdf" defaultScale={SpecialZoomLevel.PageWidth}
                                        viewMode={ViewMode.SinglePage} 
                                        renderLoader={() => (<LoadingSpinner show={true} />)}
                                        renderError={(error: LoadError) => {
                                            errorViewerFilePdf.current = true; // Imposta l'errore senza causare un re-render
                                            return renderErrorViewerPdf();
                                        }}
                                        onDocumentLoad={() => {
                                            errorViewerFilePdf.current = false;
                                        }}
                                        /> 
                                </Worker>
                                
                            }
                        </Dialog>
                        : <></>
                    }                    
            </div>
        </>
        );
}
        